<template>
    <div>
        <v-card class="course-additional-activities background-transparent shadow-none">
            <v-btn class="background-transparent" @click="showRevisions()">Revisions</v-btn>
        </v-card>
        <GroupList />
    </div>    
</template>

<script>
import axios from '../axios-auth'
 import { mapGetters } from 'vuex'
 import DataTable from '../components/data/data_table.vue'
 import GroupList from '../components/data/group_list.vue'
 import * as icn from '../assets/task_icons.js'

export default {
    data() {
        return {

        }
    },
    computed:
        mapGetters([
        ])
    ,    
    components: {
        GroupList,
        DataTable
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            // all students lessons
        /*    let _data = {
                course_id: this.$route.params.course_id,
            }
            axios.post('/get-students-groups-revisions', _data, this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.tasks = res.data.tasks
                    this.students = res.data.students

                    this.refreshGroups()
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                }) */
        },
        showRevisions() {
            this.$router.push({name:'revisions_teacher_revisions', params: {course_id: this.$route.params.id}})
        }
    }
}
</script>